import { DateValueI, FilterOptionI } from '@/utils/filterDrawers'

// The date picker returns a Date at LOCAL midnight of the clicked calendar day,
// so the range boundaries are derived in LOCAL time. Using setUTCHours here
// would, for any positive UTC offset, snap to the previous UTC day and shift
// the whole range back a day.
export const getStartOfDay = (date: Date) => {
  const copy = new Date(date)
  copy.setHours(0, 0, 0, 0)
  return copy.toISOString()
}

export const getEndOfDay = (date: Date) => {
  const copy = new Date(date)
  copy.setHours(23, 59, 59, 999)
  return copy.toISOString()
}

/**
 * Rehydrates the custom-range date pickers from a saved boundary. The stored
 * instant's LOCAL calendar day is rebuilt as a local date pinned to noon, so
 * it round-trips to the day the user actually clicked (and noon keeps timezone
 * offsets from nudging the displayed day).
 */
export const getCustomDates = (
  option: FilterOptionI<number | DateValueI> | null | undefined
) => {
  const toLocalSameDay = (iso: string) => {
    const local = new Date(iso)
    return new Date(local.getFullYear(), local.getMonth(), local.getDate(), 12)
  }
  const customValue = option?.value as DateValueI | undefined
  const now = new Date()
  return {
    startDate: customValue?.gte ? toLocalSameDay(customValue.gte) : now,
    endDate: customValue?.lte ? toLocalSameDay(customValue.lte) : now,
  }
}
